const supportedLanguages = ["en", "fr", "de", "nl"];
const languageSwitcher = document.getElementById("language_switcher");        
const languageLinks = languageSwitcher.querySelectorAll("ul li a");

var website = "https://www.fineoglass.eu";

var lang = getLocale();
let choices = [];

setLangParam(lang);

function setLangParam(language) {
    var url = new URL(window.location.href);
    var logo = document.querySelector("#logo a");

    // Set a query parameter
    url.searchParams.set("locale", language);

    // Replace the current URL with the updated one
    window.history.replaceState({}, "", url.toString());

    if (lang !== "en") 
        //update the website link 
        logo.setAttribute("href", website + "/" + language);
    else 
        logo.setAttribute("href", website);

}

// Function to initialize i18next
function initI18n() {
    i18next.init({
        lng: lang,
        resources: messages,
    });
}

function translate(key) {
    const keys = (lang + "." + key).split(".");
    
    let result = messages;

    keys.forEach((k) => {
        result = result[k];
        if (!result) {
            // If at any point the key is not found, return the original key
            return key;
        }
    });

    // Return the translation or the original key if not found
    return result || key;
}

// Get language
function getLocale() {
    let locale = getUrlParameter("lang");

    if (locale == "") 
        locale = localStorage.locale == undefined ? navigator.language.split("-")[0] : localStorage.locale;

    if (!supportedLanguages.includes(locale)) 
        locale = "en";

    return locale;
}

// Function to change the language
function changeLanguage(language) {
    lang = language;
    setLangParam(language);
    updateAllTranslatedContent(document.body); // Call your function to update translated content
    resetChoices();
}

// Function to update translated content after changing the language
function updateAllTranslatedContent(element) {
    // Update textContent if a translation key is found
    if (element.dataset.i18nKey) {
        const translationKey = element.dataset.i18nKey;

        if (element.placeholder !== undefined) 
            // Update placeholder for form elements
            element.placeholder = translate(translationKey);
        else {
            // Update textContent for other elements
            element.innerHTML = translate(translationKey);
        }
    }
    // Recursively traverse child elements
    for (const child of element.children) {
        updateAllTranslatedContent(child);
    }
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function updateLanguageList(selectedLanguage) {
    const activeLanguageSpan = document.getElementById("activeLanguage");

    // Update the active language outside the ul
    activeLanguageSpan.textContent = selectedLanguage;

    // Update the language list in the ul
    languageLinks.forEach((l) => {
        if (l.textContent.toLowerCase() === selectedLanguage) 
            l.parentElement.style.display = "none"; // Hide the selected language in the list
        else 
            l.parentElement.style.display = "block";
    });
}

// Attach click event listeners to language switcher links
document.addEventListener("DOMContentLoaded", function () {
    initI18n(); // Initialize i18next

    if (languageSwitcher) {

        languageLinks.forEach((link) => {
            link.addEventListener("click", function (event) {
                event.preventDefault();
                const selectedLanguage = this.textContent.toLowerCase();

                updateLanguageList(selectedLanguage);
                
                // Change the language
                changeLanguage(selectedLanguage);
            });
        });
    }

    // Initial update of the list 
    updateLanguageList(lang);

    // Initial update of translated content
    updateAllTranslatedContent(document.body);
    // resetChoices();
    initChoices();
});
